module.exports = __webpack_public_path__ + "img/card-EBD9FF.7314f11e.png";